import axios from 'axios'
import {stringify} from 'qs'
import router from "@/router"
import {getStorage, isDevEnv,getLanguage} from "@/utils"
import i18n from "@/i18n"

//开发环境下使用本地的8088端口
axios.defaults.baseURL = window.configIP
//axios.defaults.baseURL = isDevEnv? "/api" : window.configIP
axios.defaults.withCredentials = true
axios.defaults.headers["Access-Control-Allow-Origin"] = "*" //允许跨域
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.timeout = 10000

//请求拦截器
axios.interceptors.request.use((config) => {
  if(isDevEnv) console.log("Request Success: ", config)

  if(getStorage("token")) {
    config.headers.Authorization = getStorage("token")
  }
  return config
}, (error) => {
  if(isDevEnv) console.error("Request Error: ",error)

  return Promise.reject(error)
})

//响应拦截器
axios.interceptors.response.use((res) => {
    if(isDevEnv) console.log("Response Success: ", res)

    //没有登录 跳转到首页
    if(res.data == "unlogin") {
      sessionStorage.clear()
      router.push('/sign')
      return {
        code: '500',
        message: i18n.t('Q13')
      }
    } else {
      return res.data
    }
  },
  (error) => {
    if(isDevEnv) console.error("Response Error: ",error)

    var data = {
      code: '500',
      message: i18n.t('m89'),
      result: {}
    }
    return Promise.resolve(data)
  })

//为每个请求添加查询参数language和请求头Accept-Language，用于本地化

export default {
  get(url, param) {
    if (!param) param = {}
    const language = getLanguage();
    param.language = language
    return axios.get(url, {params: param, headers: {"Accept-Language": language}})
  },
  post(url, param) {
    if (!param) param = {}
    const language = getLanguage();
    param.language = language
    return axios.post(url, stringify(param), {headers: {"Accept-Language": language}})
  },
  upLoadPost(url, param) {
    const language = getLanguage();
    return axios.post(url, param, {headers: {"Accept-Language": language}})
  }
}



// WEBPACK FOOTER //
// ./src/services/service.js